import useWindowSize from './window-size';

const useIsMobile = () => {
    const windowWidth = useWindowSize().width;
    return windowWidth <= 900;
};

export default useIsMobile;
